import axios from 'axios'

const baseUrl = '/api/marketplace/'

// state
const state = () => ({
  user: null,
  token: localStorage.getItem('token') || null
})

// getters
const getters = {
  auth: state => () => { return state.token }
}

// actions
const actions = {
  authUser ({ commit, dispatch }, payload) {
    const promise = axios.post(baseUrl + 'login', payload)
    promise.then(res => {
      console.log(res)
      commit('setToken', res.data)
      commit('setUser', res.data)
      dispatch('getUser')
    })
    return promise
  },
  register ({ commit, dispatch }, payload) {
    const promise = axios.post(baseUrl + 'register', payload)
    promise.then(data => {
      commit('setToken', data)
      commit('setUser', data)
      dispatch('getUser')
    })
      .catch(err => {
        console.log(err)
      })
    return promise
  },
  async getUser ({ dispatch, commit }) {
    await axios.get(baseUrl + 'auth')
      .then(res => {
        commit('setUser', res)
        window.Echo.private('user.' + res.data.data.id)
          .listen('.billing-changed', (e) => {
            dispatch('getAuth')
            dispatch('invoices/getSocketOpenedInvoices', null, { root: true })
          })
      })
      .catch(err => {
        console.log(err)
      })
  },
  getAuth ({ dispatch, commit }) {
    axios.get(baseUrl + 'auth')
      .then(res => {
        commit('setUser', res)
      })
      .catch(err => {
        console.log(err)
      })
  },
  updateUserData ({ state, dispatch, commit }, data) {
    axios.put(baseUrl + 'profile', data)
      .then(res => {
        commit('setUser', res)
        this.$app.$notify(
          {
            type: 'success',
            group: 'notify',
            title: 'Данные обновлены',
            text: ''
          }
        )
      })
      .catch(err => {
        console.log(err)
      })
  },
  changePassword ({ state, dispatch, commit }, data) {
    axios.put(baseUrl + 'password', data)
      .then(res => {
        this.$app.$notify(
          {
            type: 'success',
            group: 'notify',
            title: 'Пароль успешно изменен',
            text: ''
          }
        )
      })
      .catch(err => {
        console.log(err)
      })
  },
  logout ({ commit }) {
    axios.delete(baseUrl + 'logout')
    commit('clearToken')
  }
}

// mutations
const mutations = {
  setToken (state, payload) {
    const data = payload.data

    if (data !== undefined) {
      localStorage.setItem('token', data.api_token)
      state.token = data.api_token
      // TODO add token to axios
      location.reload()
    }
  },
  setUser (state, payload) {
    const { data } = payload.data
    if (data !== undefined) {
      state.user = data
      this.dispatch('invoices/getInvoiceUser', data.id, { root: true })
    }
  },
  clearToken (state) {
    state.token = ''
    state.user = null
    localStorage.setItem('token', '')
    location.reload()
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
